import { useEffect, useState } from 'react';

import { debounce } from '../utils';

const isBrowser = typeof window !== 'undefined';

function getScrollPosition() {
  if (isBrowser) {
    const scrollPositionY = window.scrollY;
    return scrollPositionY;
  }
}

let lastScrollPosition = 0;

function getScrollDirection() {
  if (isBrowser) {
    const currentScrollPosition = window.scrollY;

    const scrollPositionDifference = lastScrollPosition - currentScrollPosition;

    lastScrollPosition = currentScrollPosition;

    if (scrollPositionDifference === 0) {
      return 'static';
    }

    return scrollPositionDifference > 0 ? 'up' : 'down';
  }
}

export default function useVerticalScrollPosition() {
  const [scrollPositionY, setScrollPositionY] = useState(getScrollPosition());
  const [scrollDirection, setScrollDirection] = useState(getScrollDirection());

  useEffect(() => {
    if (!isBrowser) return () => false;
    // These times leave some space for the rendering
    // of the header on the first load before reading the positions
    setTimeout(() => setScrollPositionY(getScrollPosition()), 300);
    setTimeout(() => setScrollDirection(getScrollDirection()), 300);

    const handleScrollDebounced = debounce(() => {
      setScrollPositionY(getScrollPosition());
      setScrollDirection(getScrollDirection());
    }, 150);

    window?.addEventListener('scroll', handleScrollDebounced);
    return () => window?.removeEventListener('scroll', handleScrollDebounced);
  }, [setScrollDirection]);

  return {
    scrollPositionY,
    scrollDirection,
  };
}
